import type { PostFormat } from "@nlc/shared-types";

export const POST_FORMAT_LABELS: Record<PostFormat, string> = {
  post: "Post",
  reel: "Reel",
  story: "Story",
};
